export interface Credentials {
  username: string;
  password: string;
  isAdminUser: boolean;
}

export interface ExternalAuth {
  token: string;
  username: string;
  isAdminUser: boolean;
  queryString?: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  expiredIn?: number;
  expiredAt?: any;
  profileId: string;
  userName: string;
  grantedClaims?: string[];
  requireChangePw: boolean;
  queryString?: string;
  recordStatus?: string;
  errorsCode?: string;
  firstName?: string,
  lastName?: string,
  locale?: string,
}

export interface TokenErrorResponse {
  error: string;
  error_description: string;
}

export const AUTH_KEY = 'AUTH';
